import type { ColumnDef } from "@tanstack/react-table"

import { QualityApprovalStatusCell } from "../components/QualityApprovalStatusCell"
import { QualityRequestRowActions } from "../components/QualityRequestRowActions"

import { useProductTestResultColumns } from "./useProductTestResultColumns"

import type { QualityApproval } from "@/graphql/codegen/graphql"
import { formatDate } from "@/utils/date"
import { formatUserName } from "@/utils/user"

interface UseQualityRequestColumnsProps {
  onProductView: (qualityApproval: QualityApproval) => void
  onApprovalRequest: (qualityApproval: QualityApproval) => void
  onApprovalCancel: (qualityApproval: QualityApproval) => void
}

export const useQualityRequestColumns = ({
  onProductView,
  onApprovalRequest,
  onApprovalCancel,
}: UseQualityRequestColumnsProps): ColumnDef<QualityApproval>[] => {
  const baseColumns = useProductTestResultColumns({ isApprovalRequest: true })

  return [
    ...baseColumns,
    {
      accessorKey: "requestedTo",
      header: "Requested To",
      cell: ({ row }) =>
        formatUserName(row.original.productTestResult?.productTest?.product?.classification?.productManager),
      enableSorting: true,
    },
    {
      accessorKey: "submittedDate",
      header: "Submitted",
      cell: ({ row }) => formatDate(row.original.createdOn),
      enableSorting: true,
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <QualityApprovalStatusCell status={row.original.status} />,
      enableSorting: true,
    },
    {
      accessorKey: "comment",
      header: "Comment",
      cell: ({ row }) => row.original.denialReason ?? null,
      enableSorting: false,
    },
    {
      accessorKey: "actions",
      header: "",
      cell: ({ row }) => (
        <QualityRequestRowActions
          row={row}
          onProductView={onProductView}
          onApprovalRequest={onApprovalRequest}
          onApprovalCancel={onApprovalCancel}
        />
      ),
      size: 50,
      enableSorting: false,
    },
  ]
}
